'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getMpesaIntegrations() {
    const data = {
      method: 'get',
      url: 'store-mpesa-integrations'
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createMpesaIntegration(json) {
    const data = {
      method: 'post',
      url: 'store-mpesa-integration',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('M-Pesa integration created successfully')
      return true;
    }
  },
  async updateMpesaIntegration(json, id) {
    const data = {
      method: 'put',
      url: 'store-mpesa-integration/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('M-Pesa integration updated successfully')
      return true;
    }
  },
  async registerC2BUrl(json) {
    const data = {
      method: 'post',
      url: '/c2b/register',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('C2B URL registered successfully')
      return response.data
    }
  },
  async getC2BTransactions(storeId) {
    const data = {
      method: 'get',
      url: `/c2b/transactions/${storeId}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return []
  },
  async assignC2BToSale(json) {
    const data = {
      method: 'post',
      url: '/c2b/assign',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Transaction assigned to sale successfully')
      return response.data
    }
  },
}
